// Body Top Padding
$('.off-canvas--main-content').css('padding-top', $('.navbar').outerHeight() );


// Hero Slider
$('.hero').slick({
  dots: true,
  arrows: false,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 3000
});


// Testimonial Slider
$('.test-slider').slick({
  dots: false,
  arrows: true,
  adaptiveHeight: true,
  prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
  nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
  autoplay: true,
  autoplaySpeed: 3000
})


// Cart Display Toggle

$('.cart-button').click(function(e) {
  $('.cart-overlay').addClass('active');
  $('body').css('overflow', 'hidden');
  
  e.preventDefault();
});

$('.cart-bg, .cart-drawer .close').click(function() {
  $('.cart-overlay').removeClass('active');
  $('body').css('overflow', 'auto');
});


// Product Quantity Input Functionality

$('.btn-plus, .btn-minus').on('click', function(e) {
    const isNegative = $(e.target).closest('.btn-minus').is('.btn-minus');
    const input = $(e.target).closest('.input-group').find('input');
    if (input.is('input')) {
    input[0][isNegative ? 'stepDown' : 'stepUp']()
    }
})


// Product FAQs Functionality

$('.q-a').click(function() {
  $(this).toggleClass('open');
  $(this).children('.a').slideToggle();
})


$('.product-img-small').on('click', function(){
  
  var id = $(this).data('id');
  $('.product-main-img').hide();
  $('.product-main-img[data-id="'+id+'"]').show();
  
});